import { Room } from '../../models/room';

export class JoinRoom {
    public static readonly type = '[MessagingState] Join room';

    constructor(public room: Room) {}
}
